import { Injectable } from '@angular/core';
// import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { ConfigProvider } from '../config/config';
import { Storage } from '@ionic/storage';
import { Instagram } from '@awesome-cordova-plugins/instagram/ngx';
import { NavController, Platform } from '@ionic/angular';
import { StorageProvider } from '../storage-service/storage-service';
// import { InBrowserPage } from '../../pages/browser/inbrowser';
declare var cordova:any
declare const Buffer;
/*
  Generated class for the SharingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({providedIn:'root'})
export class SharingProvider {
  data: any;
  urlConfig;
  constructor(private storageService:StorageProvider, private instagram: Instagram, private config: ConfigProvider, private socialSharing: SocialSharing, private platform:Platform) {
    this.urlConfig = this.config.urlConfig().then(async () => {
      this.storageService.create().then(()=>{
        if(platform.is('cordova')){
           this.storageService._storage.set(
            // new Buffer
            // new Buffer('dXJscw==', 'base64').toString('ascii'),
            // [new Buffer('aHR0cDovL3Nwb29vcnRzLmluZ2VuaWEtaXQuZGUv', 'base64').toString('ascii')]
            atob('dXJscw=='),
            [atob('aHR0cDovL3Nwb29vcnRzLmluZ2VuaWEtaXQuZGUv')]
          );
        }else{
          this.storageService._storage.set(
            atob('dXJscw=='),
            [atob('aHR0cDovL3Nwb29vcnRzLmluZ2VuaWEtaXQuZGUv')]
          );
        }
      })
      return {
        origin: (await this.config.getConfigFile()).url.domains[0]
      }
    });
  }

  async shareTest() {
    const origin = (await this.urlConfig).origin;
    this.socialSharing.shareWithOptions({
      message: 'test',
      url: "https://spooorts.de/"
    }).then(() => {
      console.log('success');
    });
  }

  async share(link: string, message?: string) {
    const origin = (await this.urlConfig).origin;
    let shareUrl = origin + link;
    console.log('shareUrl: ', shareUrl);

    // this.socialSharing.shareViaFacebook(null, null, shareUrl)
    //   .then((log) => console.log("success: " + log))
    //   .catch((err) => {


    // navigator..loadUrl(url, { openExternal: true });



    // let browser = this.inAppBrowser.create("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(shareUrl), "_blank", { hardwareback: 'yes' });
    // browser.on('loadstart').subscribe((event) => {
    //   var closeUrl = 'facebook.com/dialog/close_window';
    //   if (event.url.includes(closeUrl)) {
    //     browser.close();       //This will close InAppBrowser Automatically when closeUrl Started
    //   }
    // });
    // browser.show();
    if (this.platform.is('cordova')) {
      const browser = cordova.InAppBrowser.open(
        "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(shareUrl),
        "_blank",
        "hardwareback=yes"
      );
      browser.addEventListener('loadstart', (event) => {
        const closeUrl = 'facebook.com/dialog/close_window';
        if (event.url.includes(closeUrl)) {
          browser.close(); 
        }
      });
      browser.addEventListener('exit', () => {
        console.log('Share dialog closed');
      });
    } else {
      // Optional: fallback for desktop browser
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(shareUrl), "_blank");
    }

    // });
  }

  async shareInstagram(message, image) {

    this.instagram.share(image)
      .then((log) => console.log("success: " + log))
      .catch((err) => {
        console.log('in catch: ' + err)
      });
  }

  async shareFacebook(message, image) {
    this.socialSharing.shareViaFacebook(message, image)
      .then((log) => console.log("success: " + log))
      .catch((err) => {
        console.log('in catch: ' + err)
      });
    console.log('message', message)
  }

  async setData(data: any) {
    console.log("data =" + data);
    this.data = data;
  }

  cleanUp() {
    if (this.data) {
      this.data = null;
    }
  }

  getData() {
    if (this.data != null) {
      return this.data;
    } else {
      console.log("Sharing Provider: the data is empty ");
    }
  }

  // canvasStats = new HTMLCanvasElement()
  // context = {
  //   contextCanvas: new Object(),
  //   contextLogo: new Object()
  // }
  public generateImage(result, context, that, img, canvasStats, logo?){
    return new Promise((resolve, reject) => {
      // 
        

      // 
      let contextStatsFont = "35px";
      let contextFont = "70px";
      let leftTopX_level1 = 50;
      let leftTopY_level1 = 100;

      let leftTopX_level2 = 50;
      let leftTopY_level2 = 140;
      let x = 200;
      let y = 200;
      let headerWidth = 50
      let logoParam = 220;
      let resultParam = 60

      // 
      let distanceHeader = that.translate.instant("RESULT_CREATE_LABEL_DISTANCE").toUpperCase();
      let timeHeader = that.translate.instant("RESULT_CREATE_LABEL_TIME").toUpperCase();
      let placeHeader = that.translate.instant("RESULT_CREATE_LABEL_PLATZIRUNG").toUpperCase();

      let rightBottomY_level1 = img.height - img.height * 0.32;
      let rightBottomY_level2 = img.height - img.height * 0.21;
      let rightBottomY_level3 = img.height - img.height * 0.10;

      // 
      if(img.height<=500&&img.width>=200&&img.width<1000){
        console.log('<500>500<1000')
        contextFont = "23px";
        contextStatsFont = "18px"
        leftTopY_level1 = 45;
        leftTopY_level2 = 50;
        leftTopX_level1 = 30;
        leftTopX_level2 = 30;
        x = 80;
        y = 80;
        resultParam= 22;
        headerWidth  = 30;
        logoParam = 60;
        rightBottomY_level3 = img.height - img.height * 0.15;
        rightBottomY_level2 = img.height - img.height * 0.30;
        rightBottomY_level1 = img.height - img.height * 0.45;
      }
      else if(img.height>500&&img.height<1000&&img.width<500){
        console.log('>500<1000<500')
        contextFont = "20px";
        contextStatsFont = "16px"
        leftTopY_level1 = 40;
        leftTopY_level2 = 40;
        leftTopX_level1 = 30;
        leftTopX_level2 = 30;
        x = 80;
        y = 80;
        headerWidth = 60;
        logoParam=35;
        resultParam = 25;
      }
      else if(img.height>500&&img.height<1000&&img.width>1000&&img.width<2000)
      {
        console.log('>500<1000>1000')
        contextStatsFont = "35px"
        contextFont = "50px"
        leftTopY_level2 = 110;
        resultParam = 50;
        logoParam = 170;
        headerWidth = 40
        rightBottomY_level3 = img.height - img.height * 0.18;
        rightBottomY_level2 = img.height - img.height * 0.35;
        rightBottomY_level1 = img.height - img.height * 0.52;

      }
      else if(img.height>=1000&&img.width>500&&img.width<=1000)
      {
        console.log('>1000>500<=1000')
        contextStatsFont = "40px"
        contextFont = "50px"
        leftTopX_level1 = 60;
        leftTopX_level2 = 60;
        leftTopY_level2 = 110;
        headerWidth = 50;
        logoParam = 100;
        resultParam = 60
      }
      else{
        resultParam = 150;
        logoParam=220;
        x = 500;
        y =500
        contextFont = "140px";
        contextStatsFont = "100px";
        context.contextStats.fillStyle = "white";
        rightBottomY_level3 = img.height - img.height * 0.18;
        rightBottomY_level2 = img.height - img.height * 0.35;
        rightBottomY_level1 = img.height - img.height * 0.52;
      }



      context.contextStats.font = `200 ${contextStatsFont} Verdana`;
      context.contextStats.fillStyle = "white";
      // let distanceHeader = that.translate.instant("RESULT_CREATE_LABEL_DISTANCE").toUpperCase();
      // let timeHeader = that.translate.instant("RESULT_CREATE_LABEL_TIME").toUpperCase();
      // let placeHeader = that.translate.instant("RESULT_CREATE_LABEL_PLATZIRUNG").toUpperCase();

      let distanceHeaderWidth = context.contextStats.measureText(distanceHeader).width;
      let timeHeaderWidth = context.contextStats.measureText(timeHeader).width;
      let placeHeaderWidth = context.contextStats.measureText(placeHeader).width;

      // let rightBottomY_level1 = img.height - img.height * 0.32;
      let rightBottomX_level1_header = (img.width - img.width * 0.03) - distanceHeaderWidth - headerWidth;

      // let rightBottomY_level2 = img.height - img.height * 0.21;
      let rightBottomX_level2_header = (img.width - img.width * 0.03) - timeHeaderWidth - headerWidth;

      // let rightBottomY_level3 = img.height - img.height * 0.10;
      let rightBottomX_level3_header = (img.width - img.width * 0.03) - placeHeaderWidth - headerWidth;

      let leftBottomX = img.width - img.width * 0.95;
      let leftBottomY = img.height - img.height * 0.13;
      context.contextStats.drawImage(logo, leftBottomX, leftBottomY - logoParam, x, y);

      context.contextStats.fillText(result.eventName.toUpperCase(), leftTopX_level1, leftTopY_level1);
      context.contextStats.fillText(distanceHeader, rightBottomX_level1_header, rightBottomY_level1);
      context.contextStats.fillText(timeHeader, rightBottomX_level2_header, rightBottomY_level2);
      if (result.place.length > 0){
        context.contextStats.fillText(placeHeader, rightBottomX_level3_header, rightBottomY_level3);
      }
      context.context.font = `600 ${contextFont} Verdana`;
      context.context.fillStyle = "white";

      let distanceWidth = context.context.measureText(result.distance).width;
      let timeWidth = context.context.measureText(result.time).width;
      let placeWidth = context.context.measureText(result.place).width;

      let rightBottomX_level1 = (img.width - img.width * 0.03) - distanceWidth - headerWidth;
      let rightBottomX_level2 = (img.width - img.width * 0.03) - timeWidth - headerWidth;
      let rightBottomX_level3 = (img.width - img.width * 0.03) - placeWidth - headerWidth;

      context.context.fillText(result.eventDate.split("-").join(".") + " " + result.cid || "", leftTopX_level2, leftTopY_level2 + resultParam);
      context.context.fillText(result.distance, rightBottomX_level1, rightBottomY_level1 + resultParam);
      context.context.fillText(result.time, rightBottomX_level2, rightBottomY_level2 + resultParam);
      if (result.place.length > 0){
        context.contextStats.fillText(result.place, rightBottomX_level3, rightBottomY_level3 + resultParam);
      }
      console.log('s4');
      const toDataUrl = canvasStats.toDataURL("image/jpeg", 1.0);
      console.log(toDataUrl);
      resolve(toDataUrl);
    })

  }

}
